export default __webpack_public_path__ + "static/media/graphic.3743ceee.svg";